/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_SystemInputs */



/**
* | output |
* | --- |
* | "System" |
*
* @param {Shortcut_Keys_Group_SystemInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_system = /** @type {((inputs?: Shortcut_Keys_Group_SystemInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_SystemInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Systeme")
	if (locale === "de") return /** @type {LocalizedString} */ ("System")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sistema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Система")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sistema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("系统")
	if (locale === "ja") return /** @type {LocalizedString} */ ("システム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रणाली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sistema")
	return /** @type {LocalizedString} */ ("System")
});